// extracted by mini-css-extract-plugin
export var blink = "_6y-2";
export var cursor = "_6y-1";
export var reactMarkdown = "_6y-3";
export var streamingText = "_6y-0";